import { Grid, Box, Container, Stack, Typography } from "@mui/material";
import KpiCard from "../../components/ui/kpiCard";
import Page from "../../components/Page";
import { AudienceKpis } from "./ui/audience/AudienceKpis";
import { AudienceRetentionChart } from "./ui/audience/AudienceRentionChart";
import { AudienceAgeChart } from "./ui/audience/AudienceAgeChart";
import { AudienceTopCities } from "./ui/audience/AudienceTopCities";
import { AudienceSegments } from "./ui/audience/AudienceSegments";



export default function Audience() {
    return (
        <Page title="Analyse">
            <Container sx={{ marginTop: { xs: 3, sm: 0 } }}>
                <Stack spacing={5}>
                    <Box>
                        <Typography variant="h4">Audience</Typography>
                        <Typography color={'text.secondary'} fontSize={16}>Analysez votre audience : données démographiques, comportements et segments de visiteurs.</Typography>
                    </Box>
                    <AudienceKpis />
                    <Box>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <AudienceRetentionChart
                                    data={[
                                        { name: 'Nouveaux', value: 38 },
                                        { name: 'Récurrents', value: 62 },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <AudienceAgeChart
                                    data={[
                                        { range: '18–24', count: 120 },
                                        { range: '25–34', count: 340 },
                                        { range: '35–44', count: 210 },
                                        { range: '45+', count: 90 },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <AudienceTopCities
                                    cities={[
                                        { name: 'Abidjan', count: 620 },
                                        { name: 'Bouaké', count: 210 },
                                        { name: 'San Pedro', count: 140 },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <AudienceSegments />
                            </Grid>
                        </Grid>
                    </Box>
                    
                </Stack>

            </Container>

        </Page>

    );
}
